import { useMutation } from '@tanstack/react-query'
import { createDiversityCompanyProfile, createInclusionCompanyProfile } from 'sagas/network'
import { stringifyQueryParams } from 'utils'
import mixpanel from 'mixpanel-browser'

import { AnalyzeView } from 'types/analyze.enum'
import {
    CompanyProfilesParams,
    CreateCompanyProfilePayload,
} from 'api/actions/analyze/companyProfiles/companyProfilesActions.types'
import { Mutations } from 'api/mutations.enum'
import TAXONOMIES from 'utils/taxonomies'

export const useCreateCompanyProfile = (view: AnalyzeView, params: CompanyProfilesParams) => {
    const mutationKey =
        view === AnalyzeView.Diversity
            ? [Mutations.createDiversityCompanyProfile]
            : [Mutations.createInclusionCompanyProfile]
    const mutationFn = view === AnalyzeView.Diversity ? createDiversityCompanyProfile : createInclusionCompanyProfile

    const trackingEventName =
        view === AnalyzeView.Diversity
            ? TAXONOMIES.ANALYZE_DIVERSITY_PROFILE_CREATED
            : TAXONOMIES.ANALYZE_INCLUSION_PROFILE_CREATED

    const mutation = useMutation<void, Error, CreateCompanyProfilePayload>({
        mutationKey,
        mutationFn: (payload) => {
            return mutationFn({ payload, queryString: stringifyQueryParams(params) })
        },
        onSuccess: (_data, payload) => {
            mixpanel.track(trackingEventName, payload)
        },
    })

    return mutation
}
